import { render, staticRenderFns } from "./Valentine.vue?vue&type=template&id=2a267446&"
import script from "./Valentine.vue?vue&type=script&lang=js&"
export * from "./Valentine.vue?vue&type=script&lang=js&"
import style0 from "./Valentine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports